import type { ElementType, ReactNode } from 'react';
import StyledOverviewGroupContentParagraph from './__styled__/StyledOverviewGroupContentParagraph';

interface Props {
  as?: ElementType;
  children?: ReactNode;
  $white?: boolean;
  $small?: boolean;
}

function OverviewGroupContentParagraph({ as = undefined, children = null, $white = false, $small = false }: Props) {
  return (
    <StyledOverviewGroupContentParagraph as={as} $white={$white} $small={$small}>
      {children}
    </StyledOverviewGroupContentParagraph>
  );
}

export default OverviewGroupContentParagraph;
